import { TypedJSON } from 'typedjson';
import SportOddsBookmakerModel from '../../../../../../../models/sport-odds/sport-odds-bookmaker.model';

export const responseToBookmakerModel = (response: any) => {
	const serializer = new TypedJSON(SportOddsBookmakerModel);
	return serializer.parse(response);
};
